export default __webpack_public_path__ + "static/media/Mona_Icon.7a03016c.png";